import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import styled, { css } from 'styled-components';

export const StyledAccordion = styled(Accordion)<{ $hideLine?: boolean }>(
  ({ $hideLine }) => css`
    height: auto;
    min-height: 0;
    box-shadow: none !important;
    background-color: transparent !important;

    &.MuiPaper-root:before {
      opacity: ${$hideLine ? 0 : 1} !important;
    }

    & > div {
      padding: 0;
    }

    & ul {
      padding: 0;
      list-style: none;
    }

    & .MuiAccordionSummary-content {
      flex-direction: column;
    }
  `
);

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0 !important;
  white-space: pre-wrap;
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  min-height: 0 !important;
  padding: 0 !important;
  scroll-margin-top: 45px;

  & > div {
    display: flex;
    align-items: center;
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0 !important;
  }
`;
